// DS1.7.23
import React from 'react';
import c from 'classnames';
import { Props as IconProps } from '../../Icons/IconWrap';
import s from './NoAI.scss';

export interface Props extends IconProps {}

const NoAI: React.FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      className={c(s['root'], className)}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 12.5a4.484 4.484 0 01-1.857-.4L12.1 6.143c.257.566.4 1.195.4 1.857 0 .89-.258 1.72-.704 2.418a5.984 5.984 0 012.39-.415 6.5 6.5 0 10-5.996 4.494 5.978 5.978 0 011.07-2.176c-.4.117-.823.179-1.26.179zM3.5 8c0 .727.172 1.414.479 2.021L10.02 3.98A4.5 4.5 0 003.5 8z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#00E59B"
        d="M10.25 16l1.225-1.286 2.017 1.715L16.525 13l1.225 1.286L13.492 19l-3.242-3z"
      ></path>
    </svg>
  );
};

NoAI.displayName = 'NoAI';

export default NoAI;
